// extracted by mini-css-extract-plugin
module.exports = {"menuWrapperOpen":"AsideMenu_menuWrapperOpen__11f1A","menuWrapperClosed":"AsideMenu_menuWrapperClosed__2sNGH"};